import { render, staticRenderFns } from "./FeaturedNumberBox.vue?vue&type=template&id=745b72e4&scoped=true&"
import script from "./FeaturedNumberBox.vue?vue&type=script&lang=ts&"
export * from "./FeaturedNumberBox.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedNumberBox.vue?vue&type=style&index=0&id=745b72e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b72e4",
  null
  
)

export default component.exports